<template>
    <BasePopup @close="close" :loading="isLoading" :options="{ fixedWidth: true }">
        <div
            class="compatibility-popup-content"
            v-if="
                Object.keys(compatibilityNotes).length > 1 ||
                Object.keys(fileCompatibility).length > 1 ||
                packageSourcesCount > 0
            "
        >
            <div v-if="Object.keys(compatibilityNotes).length > 1 || Object.keys(fileCompatibility).length > 1">
                <div v-for="(compatibilityNote, type) in compatibilityNotes" :key="type">
                    <h3
                        v-if="
                            compatibilityNote.length ||
                            (fileCompatibility && fileCompatibility[type] && fileCompatibility[type].length)
                        "
                    >
                        {{ t.content["compatibility_note_" + type] }}
                    </h3>

                    <div
                        v-if="
                            compatibilityNote.length ||
                            (fileCompatibility && fileCompatibility[type] && fileCompatibility[type].length)
                        "
                        class="compatibility-content-wrapper"
                    >
                        <aside v-if="Object.keys(compatibilityNote).length > 0">
                            <div v-for="note in compatibilityNote" :key="note" class="compatibility-notes">
                                <span>{{ note }}</span>
                            </div>
                        </aside>

                        <table v-if="fileCompatibility && fileCompatibility[type] && fileCompatibility[type].length">
                            <thead>
                                <tr>
                                    <template v-if="type === 'ASSET'">
                                        <th>{{ t.content.asset_type }}</th>
                                        <th>{{ t.content.asset_format }}</th>
                                        <th>{{ t.content.software }}</th>
                                        <th>{{ t.content.usable_with }}</th>
                                    </template>
                                    <template v-else-if="['VIDEO', 'EBOOK'].includes(type)">
                                        <th>{{ t.content.software }}</th>
                                        <th>{{ t.content.software_min_version }}</th>
                                        <th>{{ t.content.software_built_version }}</th>
                                    </template>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="compatibilityRow in fileCompatibility[type]" :key="compatibilityRow">
                                    <template v-if="type === 'ASSET'">
                                        <td>
                                            {{ compatibilityRow.kindOfAsset ? compatibilityRow.kindOfAsset.name : "-" }}
                                        </td>
                                        <td>{{ compatibilityRow.fileType ? compatibilityRow.fileType.name : "-" }}</td>
                                        <td>
                                            {{ compatibilityRow.softwareName ? compatibilityRow.softwareName : "-" }}
                                        </td>
                                        <td>
                                            <template v-if="compatibilityRow.softwareVersionName">
                                                {{ t.content.software_version_from }}
                                                {{ compatibilityRow.softwareVersionName }}
                                            </template>
                                            <template v-else-if="compatibilityRow.softwareName">
                                                {{ t.content.sofware_version_flexible }}
                                            </template>
                                            <template v-else>-</template>
                                        </td>
                                    </template>
                                    <template v-else-if="['VIDEO', 'EBOOK'].includes(type)">
                                        <td>{{ compatibilityRow.softwareName }}</td>
                                        <td>
                                            {{
                                                compatibilityRow.softwareVersionName
                                                    ? compatibilityRow.softwareVersionName
                                                    : t.content.sofware_version_flexible
                                            }}
                                        </td>
                                        <td>
                                            {{
                                                compatibilityRow.createdWithSoftwareVersionName
                                                    ? compatibilityRow.createdWithSoftwareVersionName
                                                    : t.content.sofware_version_flexible
                                            }}
                                        </td>
                                    </template>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div v-else>
                <h3>{{ t.popup.compatibility }}</h3>
                <aside>
                    <strong>{{ t.frontend.notice }}: </strong>
                    <span>{{ t.popup.compatibility_message }}</span>
                    <span hidden>{{ title }}</span>
                </aside>
            </div>

            <div class="content-bottom">
                <div class="content-info" v-if="packageZipSize">
                    {{ t.popup.download_size }} {{ packageZipSize }} MB
                </div>
                <div class="content-info content-bottom-separate" v-if="packageZipSize && packageSourcesCount">|</div>
                <div class="content-info" v-if="packageSourcesCount > 0">
                    <a :href="creditsUrl + '#' + packageId" :title="t.popup.check_sources">{{ t.popup.to_credits }}</a>
                </div>
            </div>
        </div>
    </BasePopup>
</template>
<script>
import axios from "@/app/axios.ts"
import BasePopup from "@/components/Frontend/BasePopup.vue"
import DownloadInfo from "@/components/Frontend/DownloadInfo.vue"
const translationsData = window.translationsData

export default {
    name: "CompatibilityPopupPackage",
    components: { BasePopup, DownloadInfo },
    props: {
        packageId: {
            type: [Number, String, Boolean],
            required: true,
        },
        showDownload: {
            type: Boolean,
            default: false,
        },
        content: {
            type: [Object, Boolean],
            default: false,
        },
    },
    data() {
        return {
            isLoading: false,
            compatibilityNotes: {},
            fileCompatibility: {},
            title: "",
            packageSourcesCount: null,
            packageZipSize: null,
            creditsUrl: null,
            t: translationsData.translations,
        }
    },
    async mounted() {
        try {
            this.isLoading = true
            const { data } = await axios.post(`/${translationsData.global_route.locale}/package/get-compatibilities`, {
                package_id: this.packageId,
            })
            this.compatibilityNotes = data?.compatibility_notes
            this.fileCompatibility = data?.file_compatibility
            this.title = data?.title
            this.packageSourcesCount = data?.package_sources_count
            this.packageZipSize = data?.package_zip_size
            this.creditsUrl = data?.credits_url
        } catch (e) {
            // this.$error(e);
        } finally {
            this.isLoading = false
        }
    },
    methods: {
        close() {
            this.$emit("close")
        },
        goto(fileUrl) {
            window.useContent(fileUrl)
        },
    },
}
</script>
<style lang="scss" scoped>
.compatibility-popup-content {
    > div {
        width: 100%;
    }

    .compatibility-content-wrapper {
        @media (width <= 767px) {
            overflow-x: scroll;

            table {
                margin-top: 0 !important;
            }
        }
    }

    h3 {
        margin-bottom: 30px !important;
        font-weight: 600 !important;
    }
}
</style>
